var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00385 1C4.5319 1 5.04809 1.15658 5.48715 1.44995C5.92621 1.74332 6.26841 2.1603 6.47049 2.64815C6.67256 3.13601 6.72544 3.67283 6.62242 4.19073C6.5194 4.70864 6.26512 5.18436 5.89173 5.55775C5.51834 5.93114 5.04262 6.18542 4.52472 6.28843C4.00681 6.39145 3.46999 6.33858 2.98214 6.1365C2.49428 5.93443 2.07731 5.59222 1.78394 5.15317C1.49057 4.71411 1.33398 4.19792 1.33398 3.66987C1.33398 2.96177 1.61527 2.28268 2.11597 1.78199C2.61667 1.28129 3.29576 1 4.00385 1V1Z",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00366 7.67444V13.0145",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00637 21.0245L6.67485 14.3497H8.00997V11.6794C8.00997 10.6172 7.58802 9.59855 6.83694 8.84747C6.08586 8.09639 5.06717 7.67444 4.00499 7.67444C2.9428 7.67444 1.92411 8.09639 1.17303 8.84747C0.421953 9.59855 0 10.6172 0 11.6794V14.3493H1.33401L2.00249 21.0241L6.00637 21.0245Z",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6786 15.0175H18.6886C19.0425 15.017 19.3818 14.8761 19.6321 14.6259C19.8824 14.3756 20.0232 14.0363 20.0237 13.6823V2.33512C20.0232 1.98117 19.8824 1.64187 19.6321 1.39159C19.3818 1.14131 19.0425 1.00049 18.6886 1H9.34351",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormation);
export default __webpack_public_path__ + "static/media/formation.176ef25f0455f72135cb9d2b3950747f.svg";
export { ForwardRef as ReactComponent };